import React, { FC, useContext } from 'react';

import { TableCell, TableHead, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';

import { useGetRoundLabel } from '../../../../common/Hooks/useGetroundLabel';
import { useEventLeaderboardsState } from '../../Context/EventLeaderboards.context';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IScoreTableTableHeadProps {
  singleRoundEvent: boolean;
  roundId?: number;
}

const ScoreTableTableHead: FC<IScoreTableTableHeadProps> = props => {
  const { singleRoundEvent, roundId } = props;

  const { events } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();
  const { selectedRound } = useEventLeaderboardsState();

  const [getRoundLabel] = useGetRoundLabel(events, Number(eventId || -1), roundId);

  return (
    <TableHead className="leaderboard__thead">
      <TableRow className="leaderboard-header">
        <TableCell className="leaderboard-header__cell override index">Pos</TableCell>

        <TableCell className="leaderboard-header__cell override playerName">Player</TableCell>

        {selectedRound && !singleRoundEvent && (
          <TableCell className="leaderboard-header__cell override result">T</TableCell>
        )}

        <TableCell
          className={`leaderboard-header__cell override result ${!selectedRound ? 'rpad' : ''}`}
        >
          {getRoundLabel()}
        </TableCell>

        {roundId && roundId > 0 && (
          <TableCell className="leaderboard-header__cell override through">THRU</TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

export default ScoreTableTableHead;
